import { useState } from "react";
import { useDebounce } from "use-debounce";
import { useCostChangeHistoryQueries } from "./useCostChangeHistoryQueries";

export const useCostChangeHistory = ({ recipeId }) => {
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 50,
  });
  const [search, setSearch] = useState("");

  const tableState = {
    sorting,
    pagination,
    search,
  };

  const [debouncedSearch] = useDebounce(tableState.search, 1000);

  const { costChangeHistoryQuery } = useCostChangeHistoryQueries({
    recipeId,
    pagination: tableState.pagination,
    sorting: tableState.sorting,
    debouncedSearch,
  });

  const onSearchHandler = (search) => {
    setSearch(search);
    setPagination((prevPagination) => ({
      ...prevPagination,
      pageIndex: 1,
    }));
  };

  return {
    costChangeHistoryQuery,
    tableState,
    tableHelpers: {
      setPagination,
      setSorting,
      onSearchHandler,
    },
  };
};
